module.exports = __webpack_public_path__ + "static/media/bbmVI-16.e83ce92e.png";